import { EntityConfig, entityStandardFormFields } from '@shapeable/core';
import { Edition as MyType } from '@shapeable/gesda-types';
import { EntityTypeName } from '@shapeable/types';
const gql = String.raw;


export const Edition: EntityConfig<MyType> = {
  name: 'Edition',
  type: 'taxonomy',
  list: {
    resultsVariant: 'list',
  },
  autoRoutes: ['create', 'update', 'list'],
  form: {
    fields: {
      ...entityStandardFormFields,
      label: { type: 'text' },
      numericValue: { type: 'int' },
    }
  },
}; 

/*

export type Edition = Entity & {
  label?: string;
  numericValue: number;

  topicExpertise: TopicExpertise[];
};

*/